import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { ApiClient } from "./client";

const ApiClientContext = createContext<ApiClient | null>(null);

export function ApiClientProvider({
  client,
  children,
}: {
  client: ApiClient;
  children: ReactNode;
}) {
  return <ApiClientContext value={client}>{children}</ApiClientContext>;
}

/** The configured API client. Missing provider is a wiring bug, so it fails loudly. */
export function useApiClient(): ApiClient {
  const client = useContext(ApiClientContext);
  if (!client)
    throw new Error("useApiClient() called outside <ApiClientProvider> (see AppProviders)");
  return client;
}

/** For shared chrome (e.g. the idle-session monitor) that also renders in UI tests with no API client wired. */
export function useOptionalApiClient(): ApiClient | null {
  return useContext(ApiClientContext);
}
